import React, { useState } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { logout } from "../../../Redux/actions/user";
import CustomModal from "../../../UtilityComponents/customModal";
import ResetPassword from "./resetPassword";
import "./index.css";

function UpdatePassword(props){
    
    let { user } = props; 
 
    const [updatingPassword, setUpdatingPassword] = useState()
    const [modal, setModal] = useState(false);

    document.title = "Update Password | E-Manager Console | Techforce.ai";

    const handleLogout = async (e) => {
      props.history.push("/")
      props.logout();      
    }
    
    const toggle = (e) => {
       setModal(!modal);
    }
    const createModal = (e) => {
      e.preventDefault();
      toggle()
    }
    return (
      <div className="profile-container">
        <div className="sub-head">
          <h2 className="heading">Change Password</h2>
        </div>
        <div className="form-container">
          <div className="center">
          <form>
            <p>Click on the below button to change your password</p>
            <div className="text-center" style={{marginTop:"20px"}}>
              <button 
                  onClick={createModal} 
                  style={{width : "150px",marginRight:"800px",whiteSpace:"nowrap"}} 
                  className="btn btn-primary">
                    {updatingPassword ? "loading .." : "Change Password"}
              </button>
            </div>
          </form>
          </div>
         </div> 
         { modal ? <CustomModal comp={<ResetPassword handleLogout = {()=>handleLogout()} user={props.user} toggle={() => toggle()}/>} 
                        name="Change Password"
                        toggle={() => toggle()}
                        modal={modal} /> : null 
            }
      </div>
    );
}

const mapStateToProps = (state) => ({
    user: state.user
})
const mapDispatchToProps = dispatch => ({
  logout: bindActionCreators(logout, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(UpdatePassword);